import _ from 'lodash';

import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';

export class OnOffClientPlugin extends SmartenitPlugin {
  public getEffectOptions(): any {
    return null;
  }

  public getEffectAttribute(): string | null {
    return null;
  }

  public getEffectMethod(context?: any): string | null {
    return null;
  }

  public getConditionOptions(methods?: any): any {
    if (methods) {
      const conditionOption: any[] = [];
      methods.forEach((method: any) => {
        const lowerCaseMethod = method.toLowerCase();
        if (lowerCaseMethod.indexOf('on') > -1) {
          conditionOption.push({
            displayName: _.capitalize(
              _.get(
                this.translationService.getResource(),
                'AR.CONDITIONS_NL.TURN_ON',
                ''
              )
            ),
            method: {
              name: 'On'
            },
            name: 'turn On',
            value: 'on'
          });
        } else if (lowerCaseMethod.indexOf('off') > -1) {
          conditionOption.push({
            displayName: _.capitalize(
              _.get(
                this.translationService.getResource(),
                'AR.CONDITIONS_NL.TURN_OFF',
                ''
              )
            ),
            method: {
              name: 'Off'
            },
            name: 'turn Off',
            value: 'off'
          });
        }
      });
      return conditionOption;
    }

    return [
      {
        displayName: _.get(
          this.translationService.getResource(),
          'AR.CONDITIONS_NL.SWITCH_1',
          ''
        ),
        method: {
          name: 'Toggle'
        },
        name: 'Switch 1',
        value: '1'
      },
      {
        displayName: _.get(
          this.translationService.getResource(),
          'AR.CONDITIONS_NL.SWITCH_2',
          ''
        ),
        method: {
          name: 'Toggle'
        },
        name: 'Switch 2',
        value: '2'
      },
      {
        displayName: _.get(
          this.translationService.getResource(),
          'AR.CONDITIONS_NL.SWITCH_3',
          ''
        ),
        method: {
          name: 'Toggle'
        },
        name: 'Switch 3',
        value: '3'
      }
    ];
  }

  public getConditionAttribute(): string | null {
    return null;
  }

  public processMessage(
    message: IWebSocketDeviceMessage,
    timestamp?: number
  ): any {
    const attribute = message && message.attributeOrMethod;
    const supportedMethods = [
      'Off',
      'On',
      'Toggle',
      'OffWEffect',
      'OnWRecallGlobalScene',
      'OnWTimedOff'
    ];

    if (attribute && supportedMethods.indexOf(attribute) > -1) {
      // TODO handle received methods
    }

    return this.state;
  }
}
